import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import AppBar from '@material-ui/core/AppBar'
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

import { setCurrentTab } from './actions'
import About from './About'
import CPU from './CPU'
import Datastore from './Datastore'
import Editor from './Editor'
import Memory from './Memory'
import Temperature from './Temperature'
import Threads from './Threads'
import Events from './Events'
import { IState, IStatus } from './types'

const styles = (theme: Theme) => createStyles({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
    height: '100%',
  },
})

interface IMyTabsProps extends WithStyles<typeof styles> {
  theme: Theme
}

interface IConnectedProps {
  currentTab: number,
  analysisStatus: IStatus
}

interface IDispatchProps {
  setCurrentTab: (currentTab: number) => void
}

type IAllProps = IConnectedProps & IMyTabsProps & IDispatchProps

class MyTabs extends React.Component<IAllProps> {
  public state = {
    activeTab: 0,
  }

  public handleChange = (_event: any, activeTab: number) => {
    this.props.setCurrentTab(activeTab)
  }

  public render () {
    const { currentTab, classes, analysisStatus } = this.props
    const isStatusBrowsing: boolean = (analysisStatus === 'BROWSING')

    return (
      <div className={classes.root}>
        <AppBar position={'static'}>
          <Tabs value={currentTab} onChange={this.handleChange}>
            <Tab label={'logs'} disabled={!isStatusBrowsing} />
            <Tab label={'datastore'} disabled={!isStatusBrowsing} />
            <Tab label={'temperature'} disabled={!isStatusBrowsing} />
            <Tab label={'threads'} disabled={!isStatusBrowsing} />
            <Tab label={'cpu'} disabled={!isStatusBrowsing} />
            <Tab label={'memory'} disabled={!isStatusBrowsing} />
            <Tab label={'events'} disabled={!isStatusBrowsing} />
            <Tab label={'About'} />
          </Tabs>
        </AppBar>
        {currentTab === 0 && <Editor />}
        {currentTab === 1 && <Datastore />}
        {currentTab === 2 && <Temperature />}
        {currentTab === 3 && <Threads />}
        {currentTab === 4 && <CPU />}
        {currentTab === 5 && <Memory />}
        {currentTab === 6 && <Events />}
        {currentTab === 7 && <About />}
      </div>
    )
  }
}

const mapStateToProps = (state: IState): IConnectedProps => ({
  currentTab: state.currentTab,
  analysisStatus: state.status
})
const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  setCurrentTab: (currentTab: number) => dispatch(setCurrentTab(currentTab))
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MyTabs))



// WEBPACK FOOTER //
// ./src/Tabs.tsx